import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsZendframeworkComponent } from './simple-icons-zendframework.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsZendframeworkComponent ],
    exports:      [ SimpleIconsZendframeworkComponent ],
    bootstrap:    []
})
export class SimpleIconsZendframeworkModule {}
